var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "background",
    d: "M18.3 1C16.1875 1 14.25 1.9875 13 3.6125C11.75 1.9875 9.8125 1 7.7 1C4.00625 1 1 4.01875 1 7.73125C1 9.475 1.6625 11.1312 2.86875 12.3937L12.3188 21.9375L13 22.625L13.6812 21.9375L22.95 12.575C24.2625 11.3063 25 9.58125 25 7.73125C25 4.01875 21.9937 1 18.3 1Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M18.3 1.9625C21.4687 1.9625 24.0438 4.54375 24.0438 7.73125C24.0438 9.36875 23.3625 10.8437 22.275 11.8937L13 21.2563L3.5625 11.725C2.575 10.6875 1.9625 9.28125 1.9625 7.73125C1.9625 4.54375 4.53125 1.9625 7.70625 1.9625C10.0938 1.9625 12.1375 3.425 13.0063 5.5125C13.8625 3.43125 15.9125 1.9625 18.3 1.9625ZM18.3 1C16.1875 1 14.25 1.9875 13 3.6125C11.75 1.9875 9.8125 1 7.7 1C4.00625 1 1 4.01875 1 7.73125C1 9.475 1.6625 11.1312 2.86875 12.3937L13 22.625L22.95 12.575C24.2625 11.3063 25 9.58125 25 7.73125C25 4.01875 21.9937 1 18.3 1Z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1184ebd0ad8aa30326b515ebf7640194.svg";
export { ForwardRef as ReactComponent };